import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  // Define background-only operations (these won't trigger the main loading$)
  private readonly backgroundOperationNames = new Set<string>([
    'configuratorFpcs',
    'VehiclesFromTestItApi',
  ]);

  // Counters for tracking
  private foregroundLoadingCount = 0;
  private backgroundLoadingCount = 0;

  // Public observables
  private foregroundLoadingSubject = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.foregroundLoadingSubject.asObservable();

  private backgroundLoadingSubject = new BehaviorSubject<boolean>(false);
  public readonly loadingInBackground$ = this.backgroundLoadingSubject.asObservable();

  show(operationName: string): void {
    const isBackground = this.backgroundOperationNames.has(operationName);

    // Increment foreground only if not background operation
    if (!isBackground) {
      this.foregroundLoadingCount++;
      if (this.foregroundLoadingCount === 1) {
        this.foregroundLoadingSubject.next(true);
      }
    } else {
      // Increment global/background count
      this.backgroundLoadingCount++;
      if (this.backgroundLoadingCount === 1) {
        this.backgroundLoadingSubject.next(true);
      }
    }
  }

  hide(operationName: string): void {
    const isBackground = this.backgroundOperationNames.has(operationName);

    // Decrement global/background count
    if (isBackground && this.backgroundLoadingCount > 0) {
      this.backgroundLoadingCount--;
    }
    if (this.backgroundLoadingCount === 0) {
      this.backgroundLoadingSubject.next(false);
    }

    // Decrement foreground count only if not background operation
    if (!isBackground && this.foregroundLoadingCount > 0) {
      this.foregroundLoadingCount--;
    }
    if (this.foregroundLoadingCount === 0) {
      this.foregroundLoadingSubject.next(false);
    }
  }
}
